import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/serverdown.css';
import config from '../config';

const ServerDown = () => {
    const navigate = useNavigate();
    const previousRoute = sessionStorage.getItem('previousRoute') || '/';
    const [isChecking, setIsChecking] = useState(false); // State to show checking status
    const [checkAttempts, setCheckAttempts] = useState(0); // Track the number of attempts
    const [isServerBack, setIsServerBack] = useState(false); // Track if the server is back
    const intervalRef = useRef(null); // Ref to manage the interval
    const MAX_CHECK_ATTEMPTS = 6; // Maximum number of attempts before stopping
    const CHECK_INTERVAL = 30000; // 30 seconds between checks

    useEffect(() => {
        const checkServer = async () => {
            if (isChecking || checkAttempts >= MAX_CHECK_ATTEMPTS) return; // Prevent concurrent checks or excessive attempts

            setIsChecking(true); // Indicate that the server status is being checked
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 10000); // 10-second timeout

                const response = await fetch(`${config.backendUrl}/health-check/`, {
                    signal: controller.signal,
                });

                clearTimeout(timeoutId);

                if (response.ok) {
                    // Server is back up, clear the interval and navigate to the previous route
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                    }
                    sessionStorage.removeItem('serverDownRedirected'); // Clear the redirection flag
                    setIsServerBack(true);
                    navigate(previousRoute);
                }
            } catch (error) {
                // Server is still down, stay on the current page

                setCheckAttempts((prev) => prev + 1); // Increment the attempt count
            } finally {
                setIsChecking(false); // Stop indicating checking status
            }
        };

        // Check server status when component mounts
        checkServer();

        // Set up interval to check periodically
        intervalRef.current = setInterval(checkServer, CHECK_INTERVAL);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current); // Cleanup interval on component unmount
            }
        };
    }, [navigate, previousRoute, checkAttempts, isChecking]);

    return (
        <div className="serverdown-container">
            <h1>Oh là là!</h1>
            <h2>Nos serveurs prennent une petite pause</h2>
            <p>Nous travaillons dur pour tout remettre en marche. Revenez nous voir bientôt avec le sourire!</p>
            {isChecking ? (
                <p className="checking-status">Vérification du statut du serveur...</p>
            ) : (
                <p className="attempts-status">
                    Tentatives de vérification : {checkAttempts}/{MAX_CHECK_ATTEMPTS}
                </p>
            )}
            {checkAttempts >= MAX_CHECK_ATTEMPTS && (
                <p className="max-attempts-warning">
                    Nous avons atteint le nombre maximum de tentatives. Veuillez réessayer plus tard.
                </p>
            )}
            <button
                onClick={() => {
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                    }
                    setCheckAttempts(0); // Reset attempts
                    setIsServerBack(false); // Reset server status
                    window.location.reload(); // Force a manual reload
                }}
                className="retry-button"
            >
                Réessayer maintenant
            </button>
        </div>
    );
};

export default ServerDown;